import { FC } from 'react'

import { Grid, Row } from '@syconium/little-miss-figgy'

import { Section as CollectionGridSectionGrid } from '../sections/CollectionGridSection/styles'

import { CollectionGridSectionFiltersSkeleton } from './CollectionGridSectionFiltersSkeleton'
import { CollectionGridSectionTilesSkeleton } from './CollectionGridSectionTilesSkeleton'
import { Body, Hero, HeroSubtitle, HeroTitle } from './styles'

export const CollectionPageSkeleton: FC = () => {
  return (
    <Body>
      <Hero>
        <HeroTitle />
        <HeroSubtitle />
      </Hero>
      <CollectionGridSectionGrid>
        <Grid>
          <Row>
            <CollectionGridSectionFiltersSkeleton />
            <CollectionGridSectionTilesSkeleton />
          </Row>
        </Grid>
      </CollectionGridSectionGrid>
    </Body>
  )
}
